export default __webpack_public_path__ + "img/Design-Engineering-Services.919fb95b.jpg";